<template>
  <div class="notification-settings position-fixed" style="width: 100%;">
    <BHeader :title="$t('notice.title')" :isLogin="true" back="/usracc" :isInUserAccount="true"/>
    <div class="settings-card">
      <div class="settings-wrapper">
        <div class="setting-item">
          <div class="section-title">{{ $t('notice.notification_status') }}</div>
          <div class="setting-label">{{ $t('notice.enable_notifications') }}</div>
        </div>
        <div class="setting-toggle">
          <BFormCheckbox
            v-model="settings.notificationEnabled"
            switch
            :disabled="settings.disabled"
            size="lg"
            @change="updateSetting('notificationEnabled', $event)">
          </BFormCheckbox>
        </div>
      </div>
      <div class="notice-description">
        {{ $t('notice.notifications_description') }}<br>{{ $t('notice.notifications_description_text') }}
      </div>
      <div class="outline"></div>
    </div>

    <BFooter whichPage="1"/>
  </div>
</template>

<script>
import BHeader from '@/views/header.vue'
import BFooter from '@/views/footer.vue'
import { inject, onMounted, ref } from 'vue'

export default {
  name: 'notification-settings',
  components: {
    BHeader,
    BFooter,
  },
  setup () {
    const service = inject('service')

    const settings = ref({
      notificationEnabled: false, // デフォルトはオフです
      disabled: true // 制御スイッチが使用可能かどうか
    })

    const updateSetting = async (key, value) => {
      settings.value[key] = value
      let fcmToken = localStorage.getItem('fcmToken')
      const updateData = {
        pushFlag: value ? 1 : 0,
        fcmToken: fcmToken
      }
      await service.notice.updatePus(updateData)
      settings.notificationEnabled = value
    }

    const loadSettings = async () => {
      let fcmToken = localStorage.getItem('fcmToken')
      if (fcmToken == null || fcmToken === '') {
        settings.value.disabled = true
        return
      } else {
        settings.value.disabled = false
      }
      const data = {
        fcmToken: fcmToken
      }
      const response = await service.notice.getState(data)
      if (response.subscribeFlag) {
        settings.value.notificationEnabled = response.subscribeFlag === 1
      }
    }

    onMounted(() => {
      loadSettings()
    })

    return {
      settings,
      updateSetting
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-settings {
  padding: 56px 0px 56px;
  height: 100%;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .settings-card {
    /* Auto layout */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 8px 0px;
    gap: 24px;

    position: absolute;
    width: calc(100% - 32px);
    height: auto;
    left: 16px;
    top: 56px;

    /* 000 */
    background: #FFFFFF;
    border-radius: 8px;

    .settings-wrapper {
      /* Auto layout */
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0px;
      gap: 1.5rem;

      width: 100%;
      height: 40px;

      /* Inside auto layout */
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;

      .setting-item {
        /* Auto layout */
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0px;
        gap: 2px;

        width: auto;
        min-height: 40px;

        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 1;

        .section-title {
          width: auto;
          height: 18px;
          font-family: 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, 'MS Pゴシック', 'MS PGothic', sans-serif;
          font-style: normal;
          font-weight: 600;
          font-size: 13px;
          line-height: 18px;
          display: flex;
          align-items: center;
          color: #8B949E;
          flex: none;
          order: 0;
          flex-grow: 0;
        }

        .setting-label {
          width: auto;
          min-height: 20px;
          font-family: 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, 'Microsoft YaHei', '微软雅黑', sans-serif;
          font-style: normal;
          font-weight: 300;
          font-size: 15px;
          line-height: 20px;
          display: flex;
          align-items: center;
          color: #30353B;
          flex: none;
          order: 1;
          flex-grow: 0;
        }
      }

      .setting-toggle {
        /* Auto layout */
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0px;
        gap: 8px;
        width: 52px;
        height: 32px;
        border-radius: 15px;
        /* Inside auto layout */
        flex: none;
        order: 1;
        flex-grow: 0;

        :deep(.form-check) {
          min-height: auto;
          padding-left: 0;
          margin-bottom: 0;
        }

        :deep(.form-check-input) {
          float: none;
          margin-left: 0;
          width: 52px !important;
          height: 32px !important;
          border-radius: 15px !important;

          &:not(:checked) {
            background-color: #8B949E !important;
            border-color: #8B949E !important;
          }

          &:checked {
            background-color: #12C891 !important;
            border-color: #12C891 !important;
          }

          &::before {
            width: 24px !important;
            height: 24px !important;
            background-color: #FFFFFF !important;
            border: none !important;
            top: 4px !important;
            left: 4px !important;
          }

          &:checked::before {
            transform: translateX(24px) !important;
          }

          &:focus, &:hover {
            box-shadow: none !important;
          }
        }

        :deep(.form-control-lg) {
          padding: 0;
        }

        :deep(.form-switch .form-check-input) {
          --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"%3e%3ccircle r="3" fill="rgba(255, 255, 255, 1)"%3e%3c/circle%3e%3c/svg%3e') !important;

          &:not(:checked)::before {
            background-color: #FFFFFF !important;
            border: none !important;
          }
        }
      }
    }
  }

  .outline {
    width: calc(100% - 32px);
    // max-width: 500px;
    height: 1px;
    top: 120px;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    background-color: #F3F7FD;
    // opacity: 1;
  }
}

.notice-description {
  margin-top: -8px;
  font-size: 12px;
  line-height: 18px;
  color: #30353B;
  text-align: left;
}

</style>
